import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Content from './Content';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <Content />
  </React.StrictMode>,
);

serviceWorker.unregister();
